module.exports = __webpack_public_path__ + "img/ahorcadoNuevo3.e65a17ed.png";